import { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal'

type PropTypes = {
  show: boolean
  surveyUrl: string
  onReject: () => void
}

export const ExitSurveyModal = ({ show, surveyUrl, onReject }: PropTypes) => {
  const [showCloseInfo, setShowCloseInfo] = useState(false)

  // Show a message about how to close the modal.
  // This is only visible after the survey is finished, otherwise it's covered by the
  // iframe. But since it shows also during the survey page transitions, hide it for
  // 15 seconds, after which time the user probably have reached the final page.
  useEffect(() => {
    if (surveyUrl.length > 0 && show) {
      setTimeout(() => setShowCloseInfo(true), 15000)
    }
  }, [surveyUrl, show])

  return (
    <Modal show={show} fullscreen={true} dialogClassName="modal-exit-survey">
      <button type="button" className="close" onClick={() => onReject()}>
        <span aria-hidden="true">&times;</span>
        <span className="sr-only">Close</span>
      </button>

      <Modal.Body>
        {showCloseInfo && (
          <div
            style={{
              position: 'absolute',
              top: '30%',
              left: '10%',
              zIndex: 1,
            }}
          >
            <div>
              Thank you for completing our survey!
              <br />
              Click the close button in the top right corner to go back to
              reasonstudios.com.
            </div>
          </div>
        )}
        {surveyUrl.length > 0 && (
          <iframe
            style={{ position: 'relative', zIndex: 2 }}
            className="w-100 h-100"
            src={surveyUrl}
          ></iframe>
        )}
      </Modal.Body>
    </Modal>
  )
}
